const CRYPTO_TICKER_LIST = [
  'XBT:CUR',
  'XET:CUR',
  'XLC:CUR',
  'XTH:CUR',
  'XEO:CUR',
  'XDH:CUR',
  'XBN:CUR',
];

const DEFAULT_LIKE_TICKER_SETS: { [setOption: string]: string[] } = {
  top: [
    'SPX:IND',
    'CCMP:IND',
    'B500:IND',
    'GT10:GOV',
    'CL1:COM',
    'UKX:IND',
    'GC1:COM',
    'EURUSD:CUR',
    'GBPUSD:CUR',
  ],
  indices: [
    'SPX:IND',
    'B500:IND',
    'UKX:IND',
    'INDU:IND',
    'RTY:IND',
    'CCMP:IND',
    'NKY:IND',
    'HSI:IND',
    'DAX:IND',
  ],
  rates: [
    'GT5:GOV',
    'GT10:GOV',
    'GTJPY10Y:GOV',
    'GTGBP10Y:GOV',
    'GTFRF10Y:GOV',
    'GTDEM10Y:GOV',
    'GTCAD10Y:GOV',
    'GTHKD10Y:GOV',
  ],
};

export const UK_LIKE_TICKER_SETS: { [setOption: string]: string[] } = {
  ...DEFAULT_LIKE_TICKER_SETS,
  top: [
    'UKX:IND',
    'SPX:IND',
    'USDGBP:CUR',
    'EURGBP:CUR',
    'CL1:COM',
    'CCMP:IND',
    'DAX:IND',
    'FTSEMIB:IND',
  ],
};

const TICKER_BARS: { [pageId: string]: string[] } = {
  default: [
    'SPX:IND',
    'CCMP:IND',
    'CL1:COM',
    'GT10:GOV',
    'EURUSD:CUR',
    'INDU:IND',
    'RTY:IND',
    'GC1:COM',
    'XAG:CUR',
    'NKY:IND',
    'HSI:IND',
    'UKX:IND',
    'DAX:IND',
    'GBPUSD:CUR',
    'USDJPY:CUR',
    'XBT:CUR',
    'XET:CUR',
  ],
  'premium-uk': [
    'UKX:IND',
    'SPX:IND',
    'USDGBP:CUR',
    'EURGBP:CUR',
    'CO1:COM',
    'CCMP:IND',
    'DAX:IND',
    'FTSEMIB:IND',
    'NKY:IND',
    'HSI:IND',
    'GC1:COM',
    'XAG:CUR',
    'XBT:CUR',
    'XET:CUR',
  ],
  'cryptocurrencies-v2': CRYPTO_TICKER_LIST,
  cryptocurrencies: CRYPTO_TICKER_LIST,
  'technology-ai': [
    'MSFT:US',
    'GOOGL:US',
    'NVDA:US',
    'BIDU:US',
    'SNTMF:US',
    'AMZN:US',
    'PLTR:US',
    'TSLA:US',
    'IBM:US',
    'META:US',
    'MU:US',
    'CRM:US',
    'AAPL:US',
  ],
  phoenix: [...new Set(Object.values(DEFAULT_LIKE_TICKER_SETS).flat())],
  'phoenix-uk': [...new Set(Object.values(UK_LIKE_TICKER_SETS).flat())],
};

export { DEFAULT_LIKE_TICKER_SETS, TICKER_BARS };
